import 'react-datepicker/dist/react-datepicker.css';
import { createRoot } from 'react-dom/client';
import { LicenseInfo as DataGridLicenseInfo } from '@mui/x-data-grid-pro';
import { LicenseInfo, LicenseInfo as MuiXLicenseInfo } from '@mui/x-license';
import * as Sentry from '@sentry/react';
import App from './components/App';
import { initializeFirebase } from './configs/firebase';
// На время тестирования уведомлений
import './entities/notification/utils';
import './shared/config/i18n';
import './styles.css';

LicenseInfo.setLicenseKey(process.env.X_DATA_GRID_PRO_LICENSE as string);

const muiXLicenseKey = process.env.X_DATA_GRID_PRO_LICENSE;

MuiXLicenseInfo.setLicenseKey(muiXLicenseKey!);
DataGridLicenseInfo.setLicenseKey(muiXLicenseKey!);

Sentry.init({
  release: process.env.BUILD_VERSION,
  dsn: 'https://335dc438405db02b29eb00e5b53a0280@o4507683609313280.ingest.de.sentry.io/4507683613179984',
  // Sentry.browserTracingIntegration disabled: span collection on /tickets
  // (lots of fetches) blocks the main thread for ~1 minute when serialized.
  integrations: [Sentry.replayIntegration()],
  tracesSampleRate: 0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const root = createRoot(document.getElementById('root')!);
root.render(<App />);

initializeFirebase();

if (module.hot) module.hot.accept();
